import { getItemFromStorage, storeKeys } from '../../utils/Storage';
import * as userActions from '../actions/user'; 

const initialState = {
    userId: getItemFromStorage(storeKeys.userdata)?.id,
    firstName: getItemFromStorage(storeKeys.userdata)?.firstName,
    lastName: getItemFromStorage(storeKeys.userdata)?.lastName,
    email: getItemFromStorage(storeKeys.userdata)?.email,
    role: getItemFromStorage(storeKeys.userdata)?.role,
    accessToken:getItemFromStorage(storeKeys.userdata)?.accessToken
}

export default (state = initialState, action) => {
    switch (action.type) {
        case (userActions.SET_SETLOGGEDINUSER_DETAILS):
            const { firstName, lastName, email, role, accessToken } = action.payload || {};

            return {
                ...state,
                userId: action.payload?.id,
                firstName,
                lastName,
                email,
                role,
                accessToken
            };
        default:
            return state;
    }
}